import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const EmissionFactors = defineMessages({
  ghgFactors: { id: 'app.components.select.emissionFactors.ghgFactors' },
  customFactors: { id: 'app.common.emissionFactor.customFactors' },
});

export const ScopeAndStream = defineMessages({
  placeholder: { id: 'app.components.select.scopeAndStream.placeholder' },
});

export const Tags = defineMessages({
  establishmentsWithTag: { id: 'app.components.Filter.Tags.establishmentsWithTag' },
  placeholder: { id: 'app.components.Filter.Tags.placeholder' },
  addCustomTag: { id: 'app.components.select.tags.addCustomTag' },
});

export const Recipients = defineMessages({
  placeholder: { id: 'app.components.select.recipients.placeholder' },
  addCustomRecipient: { id: 'app.components.select.recipients.addCustomRecipient' },
});

export const Registers = defineMessages({
  placeholder: { id: 'app.components.select.registers.placeholder' },
});

export const Tenants = defineMessages({
  placeholder: { id: 'app.components.select.tenants.placeholder' },
});

export const RecurringExportPeriod = defineMessages({
  placeholder: { id: 'app.components.select.recurringExportPeriod.placeholder' },
  dailyStandard: { id: 'app.components.select.recurringExportPeriod.dailyStandard' },
  dailyCustom: { id: 'app.components.select.recurringExportPeriod.dailyCustom' },
  weeklyStandard: { id: 'app.components.select.recurringExportPeriod.weeklyStandard' },
  weeklyCustom: { id: 'app.components.select.recurringExportPeriod.weeklyCustom' },
  monthlyStandard: { id: 'app.components.select.recurringExportPeriod.monthlyStandard' },
  monthlyCustom: { id: 'app.components.select.recurringExportPeriod.monthlyCustom' },
  quarterlyStandard: { id: 'app.components.select.recurringExportPeriod.quarterlyStandard' },
  quarterlyCustom: { id: 'app.components.select.recurringExportPeriod.quarterlyCustom' },
  yearlyStandard: { id: 'app.components.select.recurringExportPeriod.yearlyStandard' },
  yearlyCustom: { id: 'app.components.select.recurringExportPeriod.yearlyCustom' },
});

export const SelectMessages = defineMessages({
  loadingPlaceholder: { id: 'app.components.form.select.loadingPlaceholder' },
});
